<template>
  <form-checkbox :id="id" :title="title">
    <input :id="id" v-model="isChecked" type="checkbox" :name="id" @input="onToggle" />
  </form-checkbox>
</template>

<script>
import FormCheckbox from '@/components/generic/presentational/atoms/formCheckbox/FormCheckbox.vue'
export default {
  components: {
    FormCheckbox,
  },
  props: {
    modelValue: Boolean,
    title: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
  },
  emits: ['change', 'update:modelValue'],
  data() {
    return {
      isChecked: false,
    }
  },
  mounted() {
    this.isChecked = this.modelValue
  },
  methods: {
    onToggle() {
      this.isChecked = !this.isChecked
      this.$emit('change', this.isChecked)
      this.$emit('update:modelValue', this.isChecked)
    },
  },
}
</script>

<style></style>
